import debounce from "@wwdev/functions/debounce";

class Overview {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-contentable="scope"]',
			form: '[data-contentable="filters-form"]',
			filters: '[data-contentable="filters-clear"]',
			grid: '[data-contentable="grid"]'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('change', '.filter',  debounce(this.filter.bind(this), 50));
		this.$scope.on('click', '.remove-filters', (event) => this.removeFilters(event));
	}

    removeFilters(event) {
        event.preventDefault();
		this.$scope.find('.filter').each(function (it, el) {
			if ($(el).prop("checked")) {
				$(el).prop("checked", false).change();
				let $label = $(el).closest('.blog-filter').find('.filter-label');
				$label.removeClass('active');
			}
		});
		$(event.currentTarget).addClass('active');
    }

	filter() {
		let $form = this.$scope.find(this.config.form);
		let formdata = new FormData($form[0]);
		let query = new URLSearchParams(formdata).toString()
		history.pushState($form.serialize(), '', '?' + query);

		formdata.append('action', 'filter');

		$.ajax({
			url: $form.attr('action'),
			method: 'get',
			data: (new URLSearchParams(formdata).toString()),
			success: (response) => {
				this.$scope.find(this.config.filters).html(response.filters);
				this.$scope.find(this.config.grid).html(response.grid);
			}
		})
	}
}

export default new Overview;
